export default "__VITE_ASSET__CsgKWNCk__"